import type { UpdateProfileRequest, UserResponse } from '../types/user';
import type { PageResponse } from '../types/api';
import { api } from './api';

export async function getCurrentUser(): Promise<UserResponse> {
  const { data } = await api.get<UserResponse>('/users/me');
  return data;
}

export async function getUserById(id: string): Promise<UserResponse> {
  const { data } = await api.get<UserResponse>(`/users/${id}`);
  return data;
}

export async function updateProfile(
  body: UpdateProfileRequest,
): Promise<UserResponse> {
  const { data } = await api.put<UserResponse>('/users/me', body);
  return data;
}

export async function getClients(
  search = '',
  page = 0,
  size = 20,
): Promise<PageResponse<UserResponse>> {
  const { data } = await api.get<PageResponse<UserResponse>>('/users/clients', {
    params: { search, page, size },
  });
  return data;
}

export async function promoteToAdmin(id: string): Promise<UserResponse> {
  const { data } = await api.post<UserResponse>(`/users/${id}/promote`);
  return data;
}

export async function demoteToClient(id: string): Promise<UserResponse> {
  const { data } = await api.post<UserResponse>(`/users/${id}/demote`);
  return data;
}

export interface CreateClientRequest {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
}

export async function createClient(
  body: CreateClientRequest,
): Promise<UserResponse> {
  const { data } = await api.post<UserResponse>('/auth/register', body);
  return data;
}

export async function deleteUser(id: string): Promise<void> {
  await api.delete(`/users/${id}`);
}
